<template>
  <!-- 신규입사자 리스트 -->
  <div>
    <v-list flat class="member-list" v-for="empYmd in empYmdList" :key="empYmd">
      <v-subheader class="px-6">
        <v-chip class="step approval">입사일</v-chip>
        <span class="date">{{ convertEmpYmd(empYmd) }}</span>
      </v-subheader>

      <v-list-item-group>
        <v-list-item
          :ripple="false"
          v-for="item in newEmpInfoMap[empYmd]"
          :key="item.sabun"
        >
          <v-list-item-icon>
            <v-avatar size="52">
              <v-img :src="getImgSrc(item)" :alt="item.name"></v-img>
            </v-avatar>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <span class="name" v-text="item.name"></span>
              <span
                v-show="item.jikweeNm"
                class="divider position"
                v-text="item.jikweeNm"
              ></span>
            </v-list-item-title>
            <v-list-item-subtitle>
              <span class="team" v-text="item.orgNm"></span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
// 신규입사자 조회목록 component
import { getNewMemberList } from '@/api/member.js';
import dayjs from 'dayjs';

export default {
  data: () => ({
    empYmdList: [], // 입사일자 리스트
    newEmpInfoMap: {}, // 신규입사자정보
  }),
  computed: {
    getImgSrc() {
      return item => {
        return item.fileId != null && item.seqNo != null
          ? this.$domain +
              '/cloudhr/1.0/file/display?fileId=' +
              item.fileId +
              '&seqNo=' +
              item.seqNo
          : require('@/assets/img/profile_none.png');
      };
    },
  },
  methods: {
    /* 입사일 변환 */
    convertEmpYmd(empYmd) {
      return dayjs(empYmd).format('YYYY.MM.DD');
    },

    /* 신규입사자 목록조회 */
    async fetchNewMemberList() {
      try {
        // api 호출 (최근 6개월 기준)
        const response = await getNewMemberList();
        const data = response.data.data;
        this.empYmdList = Object.keys(data);
        this.newEmpInfoMap = data;

        // 공통 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      } catch (error) {
        console.log(error);
      }
    },
  },

  created() {
    // 공통 스피너 ON
    this.$store.commit('SPINNER/ON_COMMON_SPINNER');
    this.fetchNewMemberList();
  },
};
</script>

<style></style>
